<template>
  <b-modal-kariermu
    :is-shown="value"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    centered
    size="sm"
    body-class="p-0"
    content-class="modal-content-semi_round"
    @close="closeModal"
  >
    <template #content>
      <div class="verification-container">
        <div class="text-right p-0 m-0">
          <s-button
            id="verification-invitation-close-button"
            cluster="k"
            variant="text"
            @click="closeModal"
          >
            <img src="@/assets/icons/icon_close.svg" />
          </s-button>
        </div>
        <div class="verification-content">
          <img
            src="https://cdn.karier.mu/assets/v3/default-illustration/email-reset-password.webp"
            alt="Sekolah.mu"
            class="verification-illustration"
          >
          <div class="verification-text">
            <h5 class="font-subtitle-sb-2 m-0">
              Verifikasi Akun
            </h5>
            <p
              v-if="isVerificationMandatory"
              class="font-paragraph-5 m-0"
            >
              Silakan verifikasi terlebih dahulu untuk mengakses halaman ini.
            </p>
            <p class="font-paragraph-5 m-0">
              Email verifikasi akan dikirim ke <strong>{{ userInfo.email }}</strong> atau Anda dapat mengubah email terlebih dahulu.
            </p>
          </div>
          <s-button
            id="otp-verification-entry-button"
            cluster="k"
            variant="primary"
            size="small"
            class="font-label-1 w-100"
            @click="requestOTP()"
          >
            Verifikasi Sekarang
          </s-button>
          <s-button
            id="otp-verification-entry-button"
            cluster="k"
            size="small"
            variant="text"
            class="font-label-1"
            @click="$emit('change:email')"
          >
            Ubah Email
          </s-button>
        </div>
      </div>
    </template>

    <error-message-modal
      :is-open-modal="isOpenModalError"
      title="Verifikasi Akun Diberhentikan Sementara"
      illustration="https://cdn.karier.mu/assets/v3/default-illustration/verifikasi-diberhentikan-sementara.webp"
      description="Anda telah 5 kali salah memasukkan kode. Silakan lakukan verifikasi kembali setelah 10 menit."
      @onCloseModal="isOpenModalError = false"
    ></error-message-modal>
  </b-modal-kariermu>
</template>

<script>
import { mapState } from 'vuex'
import { isMobile } from 'mobile-device-detect'
import UserAPI from '@/api/user'
import ErrorMessageModal from '@/components/molecules/modals/ErrorMessageModal.vue'

export default {
  name: 'VerificationInvitationV2',
  components: {
    ErrorMessageModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      canSendOTP: true,
      isOpenModalError: false,
      // analytics
      firebaseAnalyticsPayload: {}
    }
  },
  computed: {
    ...mapState('storage', ['accessToken']),
    ...mapState('user', ['userInfo', 'isVerificationMandatory']),
    isTemporarilyFreezeOtpVerification: {
      get () {
        return this.$store.state.user.isTemporarilyFreezeOtpVerification
      },
      set (val) {
        this.$store.commit('user/CHANGE_IS_TEMPORARILY_FREEZE_OTP_VERIFICATION', val)
      }
    }
  },
  methods: {
    logEventAnalytic (event) {
      window.firebaseAnalytics.logEvent(event, this.firebaseAnalyticsPayload)
    },
    initializeAnalytics () {
      this.firebaseAnalyticsPayload = {
        screen_url: window.location.href,
        user_profession: this.userInfo.profession_name ?? '',
        user_year_level: this.userInfo.year_level_name ?? '',
        user_is_admin: this.userInfo.is_admin ?? '',
        user_id: this.userInfo.id ?? '',
        source: isMobile ? 'web_mobile_sekolahmu' : 'web_sekolahmu'
      }
    },
    closeModal () {
      this.logEventAnalytic('verifikasi_mandatory_close')
      this.$emit('input', false)
      if (this.isVerificationMandatory) {
        if (window.history.length <= 1) {
          this.$router.push('/')
        } else {
          this.$router.go(-1)
        }
      }
    },
    setCountdownOTP () {
      const timeNow = new Date()
      const timeOtp = new Date()
      timeOtp.setTime(timeNow.getTime() + (this.sendOTPdelay * 1000))
      const otpTimestamp = Date.parse(timeOtp)
      localStorage.setItem('OTP-timestamp', otpTimestamp)
    },
    async requestOTP () {
      this.logEventAnalytic('verifikasi_mandatory_click')
      this.canSendOTP = false
      this.setCountdownOTP()
      try {
        const { data } = await UserAPI.sendEmailOTP(this.accessToken)
        if (data.status === 200) {
          this.$emit('verify')
        } else {
          throw data
        }
      } catch (error) {
        this.isTemporarilyFreezeOtpVerification = true
        this.isOpenModalError = true
      }
    }
  },
  mounted () {
    this.initializeAnalytics()
  }
}
</script>

<style scoped>
.verification-container {
  padding: 24px;
}

.verification-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.verification-illustration {
  width: 192px;
}

.verification-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
  word-break: break-word;
  text-align: center;
  margin: 0;
}

::v-deep .k-button {
  min-width: unset;
}
</style>
